import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../layout/footer/footer';
import './catalog.css';
import Beard from '../../assets/images/logo-beard2.svg';
import Img2 from '../../assets/images/img2.png';
import Refresh from '../../assets/icons/refresh.svg';
import { Form, Modal } from 'react-bootstrap';
import { LoadCanvasTemplate, loadCaptchaEnginge, validateCaptcha } from 'react-simple-captcha';
import { CatalogRegister, CatalogSendOtp, fastCharge, getCharge, getInventory } from '../../utils/api';
import { Toast } from 'primereact/toast';
import Loader from '../loader/loader'
import { Dialog } from 'primereact/dialog';
import useStickToTopModal from '../../hooks/useStickToTopModal';
import useToastNotification from '../../hooks/useToastNotification';


function CatalogComponent() {
    const toast = useRef(null);
    const [setting, setSetting] = useState('');
    const [validated, setValidated] = useState(false);
    const [time, setTime] = useState(240); // Initialize with 3 minutes (180 seconds)
    const [resendBtn, setResendBtn] = useState(true);
    const [isActive, setIsActive] = useState(false);
    const [otpVisible, setOtpVisible] = useState(false);
    const [otp, setOtp] = useState('')
    const [mobile, setMobile] = useState('');
    const [fullName, setFullName] = useState('');
    const [organName, setOrganName] = useState('');
    const [captchaInput, setCaptchaInput] = useState('');
    const [captchaValid, setCaptchaValid] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [fitstTime, setfitstTime] = useState(true);
    const [success, setSuccess] = useState('');
    const [catalogList, setCatalogList] = useState([]);
    const [downloadingId, setDownloadingId] = useState(null);
    const { modalClassName, onKeyboardClose, onKeyboardOpen, stickToTop } = useStickToTopModal();
    const { showError, showSuccess } = useToastNotification();
    const afterCardNumberRef = useRef(null);
    
    useEffect(() => {
        const settings = localStorage.getItem('settings');
        if (settings) {
            setSetting(JSON.parse(settings));
        }
    }, []);

   useEffect(() => {
    // Wait until next paint frame so <LoadCanvasTemplate/> exists
    const timer = setTimeout(() => {
        loadCaptchaEnginge(6, 'white', 'black', 'numbers');
    }, 200);

    return () => clearTimeout(timer);
    }, []);
    //setTimer
    useEffect(() => {
        let timerId;
        if (isActive && time > 0) {
            timerId = setInterval(() => {
                setTime(prevTime => prevTime - 1);
            }, 1000);
        } else if (time === 0) {
            onTimerFinish(); 
        }
        
        return () => clearInterval(timerId);
    }, [isActive, time]);

    
    const onTimerFinish = () => {
        setResendBtn(false);
    }

    const formatTime = (time) => {
        const minutes = String(Math.floor(time / 60)).padStart(2, '0');
        const seconds = String(time % 60).padStart(2, '0');
        return `${minutes}:${seconds}`;
    }
    const GetCatalog = async (e) => {
        e.preventDefault()

        const form = e.currentTarget;
        if (form.checkValidity() === true) {
            if (!validateCaptcha(captchaInput.toLowerCase())) {
                setCaptchaValid(false);
                let message = {
                    text: 'لطفا کد امنیتی را صحیح وارد کنید.'
                }
                showError(message)
                loadCaptchaEnginge(6, 'white', 'black', 'numbers');
                setCaptchaInput('')
            }
            else {
                GetOtp()
            }
        }
        setValidated(true);

    }

    const GetCatalogList = async (e) =>{

        if(e){
            e.preventDefault()
        }

        try {
            setLoading(true)

            let params = {
                mobile: mobile,
                fullName: fullName,
                oraganizitionName: organName,
                otp: otp
            }

            let res = await CatalogRegister(params)
            if (res.data.isSuccess) {
                setfitstTime(false)
                setLoading(false);
                setOtpVisible(false);
                setCatalogList(res.data.data)
            } else {
                let message = {
                    text: res.data.message
                }
                showError(message)
                loadCaptchaEnginge(6, 'white', 'black', 'numbers');
                setCaptchaInput('')
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            let message = {
                text: 'خطا در ارتباط با سرور'
            }
            showError(message)
        }
    }
    
    const GetOtp = async (e) => {
        if(e){
            e.preventDefault()
        }
        try {
            setLoading(true)

            let params = {
                mobile: mobile,
            }

            let res = await CatalogSendOtp(params)
            if (res.data.isSuccess) {
                setLoading(false);
                setOtpVisible(true);
                setTime(240);
                setIsActive(true);
                setResendBtn(true);

            } else {
                let message = {
                    text: res.data.message
                }
                showError(message)
                loadCaptchaEnginge(6, 'white', 'black', 'numbers');
                setCaptchaInput('')
                setLoading(false)
            }


        } catch (error) {
            setLoading(false)
            let message = {
                text: 'خطا در ارتباط با سرور'
            }
            showError(message)
        }
    }
    const downloadCatalogFile = async (item, index) => {
        if (!item?.downloadUrl || downloadingId !== null) return;
        try {
            setDownloadingId(item.id ?? index);
            const response = await fetch(item.downloadUrl, { credentials: 'omit' });
            if (!response.ok) {
                throw new Error('دانلود فایل با خطا مواجه شد');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const safeTitle = item.title?.trim() || 'catalog';
            link.download = safeTitle.replace(/\s+/g, '-') + '.pdf';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            showError({ text: error?.message || 'دانلود فایل با خطا مواجه شد' });
        } finally {
            setDownloadingId(null);
        }
    }
    

    return (
        <div>
            <Toast ref={toast} />

            <div className="container">
                <div className="d-flex align-items-center title gap-3">
                    <img src={Beard} alt="Logo" />
                    دانلود کاتالوگ
                </div>
                {!fitstTime && (<h5 class="text-[#0033CC] px-5 d-block " >  از حسن انتخاب شما سپاسگزاریم </h5>)}
                {fitstTime && (<h5 class="text-[#0033CC] text-sm px-5 d-block " >  لطفا برای دریافت کاتالوگ‌های کادونا اطلاعات زیر را تکمیل نمایید.</h5>)}
                
                
                
                    <div className="d-flex  justify-content-between gap-5 mt-3 w-100 flex-col-revers mb-5">
                    <div className="charging-card mb-5">
                       
                        {error && <div className="alert alert-danger">{error}</div>}
                        {success && <div className="alert alert-success">{success}</div>}
                        {fitstTime ? (
                        <Form noValidate validated={validated} onSubmit={(e) => GetCatalog(e)}>
                            <Form.Group className="mt-3">
                                <Form.Label>نام و نام خانوادگی <span className='text-[red]'> * </span></Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    value={fullName}
                                    onChange={(e) => setFullName(e.target.value)}
                                />     <Form.Control.Feedback type="invalid">
                                    لطفا نام و نام خانوادگی را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mt-3">
                                <Form.Label>نام سازمان<span className='text-[red]'> * </span></Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    value={organName}
                                    onChange={(e) => setOrganName(e.target.value)}
                                />
                                <Form.Control.Feedback type="invalid">
                                    لطفا نام سازمان را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mt-3">
                                <Form.Label>شماره موبایل <span className='text-[red]'> * </span></Form.Label>
                                <Form.Control
                                    required
                                    type="number"
                                    inputMode="numeric"
                                    value={mobile}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 11) {
                                            setMobile(e.target.value); // محدود کردن مقدار به 11 کاراکتر
                                        }
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">
                                    لطفا شماره موبایل را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>

                            
                            <Form.Group className="mt-3">
                                <Form.Label>کد امنیتی <span className='text-[red]'> * </span></Form.Label>
                                <div className="d-flex align-items-center">
                                    <Form.Control
                                        value={captchaInput}
                                        onChange={(e) => setCaptchaInput(e.target.value)}
                                        placeholder="کد امنیتی را وارد کنید"
                                        ref={afterCardNumberRef}
                                    />
                                    <div className="captcha-container d-flex align-items-center h-[48px] gap-2 ms-2">
                                        <LoadCanvasTemplate />
                                        <button
                                            type="button"
                                            onClick={() => { loadCaptchaEnginge(6, 'white', 'black', 'numbers'); setCaptchaInput('') }}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                fontSize: '18px',
                                                color: '#007BFF',
                                                marginLeft: '10px',
                                                width: '18px'
                                            }}
                                            title="تولید مجدد کد امنیتی"
                                        >
                                            <img src={Refresh} alt="" />
                                        </button>
                                    </div>
                                </div>
                            </Form.Group>
                            <button
                                className="btn btn-primary w-100 mt-1 text-center mt-3"
                                type="submit"

                                disabled={loading}
                                style={{ width: 'auto' }}
                            >دریافت کاتالوگ {loading ? <Loader /> : ''} 

                            </button>
                        </Form>) :
                        (
                        <div>
                             {catalogList.map((item, index) => (
                                <button
                                    type="button"
                                    key={index}
                                    onClick={() => downloadCatalogFile(item, index)}
                                    disabled={!item.downloadUrl || downloadingId === (item.id ?? index)}
                                    style={{
                                        backgroundColor: item.color,
                                        color: "#fff",
                                        padding: "10px 16px",
                                        textAlign: "center",
                                        display: "inline-block",
                                        borderRadius: "8px",
                                        marginTop: '15px',
                                        width: "100%",
                                        fontSize: "14px",
                                        cursor: item.downloadUrl && downloadingId !== (item.id ?? index) ? "pointer" : "not-allowed",
                                        opacity: item.downloadUrl && downloadingId !== (item.id ?? index) ? 1 : 0.6,
                                        border: "none"
                                    }}
                                >
                                    {downloadingId === (item.id ?? index) ? 'در حال دانلود...' : item.title}
                                </button>
                             ))}
                        </div>
                        )}
                    </div>

                    <div className="flex-1" style={{ textAlign: '-webkit-left' }}>
                        <img src={Img2} alt="Illustration" />
                    </div>
                </div>

            </div>
          
            <Dialog className={`animation ${stickToTop ? modalClassName : ''}`} header="کد تایید" visible={otpVisible} style={{ width: '40vw' }} onHide={() => { if (!otpVisible) return; { setOtpVisible(false); setLoading(false); loadCaptchaEnginge(6, 'white', 'black', 'numbers') } }}>
                <div className='login-card w-100'>
                    <div className='item mx-0' >
                        <h6 className='text-xl font-medium	color-primary2 mt-5'> کد تایید ارسالی  برای شماره {mobile} را وارد کنید.</h6>
                        <Form className='mt-5' noValidate validated={validated} onSubmit={(e) => GetCatalogList(e)}>
                            <Form.Group controlId="postalCode" >
                                <Form.Label style={{ fontWeight: '600' }}>کد تایید</Form.Label>
                                <Form.Control className='number' type="number" 
                                autocomplete="one-time-code" inputMode="numeric" required 
                                value={otp} 
                                onChange={(e) => {
                                    if (e.target.value.length <= 6) {
                                        setOtp(e.target.value); // محدود کردن مقدار به 11 کاراکتر
                                    }
                                }} onKeyDown={(e) => {

                                    if (e.key === 'Enter') {
                                        e.preventDefault(); // Prevent form submission
                                        GetCatalogList(e); // Call login function
                                    }
                                }} onBlur={onKeyboardClose} onFocus={onKeyboardOpen} />

                            </Form.Group>

                            <button type='button' disabled={resendBtn} className='btn w-100 text-center mt-2 number' onClick={(e) => GetOtp(e)}> {resendBtn ? formatTime(time) : 'ارسال مجدد'}</button>
                            <button className='btn btn-primary w-100 mt-2 text-center' disabled={loading} type='submit' style={{ width: 'auto' }}>ادامه {loading && <Loader />}</button>

                        </Form>
                    </div>
                </div>
            </Dialog>
          
            <div className="home-footer mt-40">
                <Footer />
            </div>

        </div>
    );
}

export default CatalogComponent;
